module.exports = __webpack_public_path__ + "img/proactive.077e9bf4.png";